<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-apply"></div>

                    <div class="msg-view">
                        <div class="text">
                            <p>请确认是否接受来自</p>
                            <p><b>{{ player_data.nickName }}</b>的周年助力邀请。</p>
                        </div>
                    </div>                 

                    <div class="notice">活动期间，同一玩家只能助力一次。</div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>


        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    width: 590px;
    height: 409px;
    background-image: url(~@/assets/images/modal/bg-modal-share.png);       
}

.t-apply{
    width: 378px;
    height: 42px;
    margin: 0 auto 40px;
    background-image: url(~@/assets/images/modal/title-web-apply.png);     
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 502px;
    height: 114px;
    margin: 0 auto;
    line-height: 1.6;
    color: #f2d47a;
    background-image: url(~@/assets/images/modal/msg-view.png); 

    font-size: 22px;

    p{
        text-align: center;
    }

    b{
        padding: 0 10px;
    }    
}

.notice{
    margin-top: 22px;
    text-align: center;
    color: #f8e1dc;
}

.warn{
    font-size: 22px;
    text-align: center;
    color: #de482b;
}

.reward-list{
    // margin-top: 14px;
}

.reward-item{
    margin: 0 20px;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding: 0 38px;
}

.u-btn.ok{
    width: 236px;
    height: 60px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 236px;
    height: 60px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}
</style>

<script>
import { apiWebApply , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            score : 0,
            success : false,
            msg : {
                1009 : '助力已满，可选择为其他玩家助力',
                1012 : '助力失败，你已助力',
                1015 : '无法助力自己',
            }            
        }
    },
    mounted(){
        this.render();
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },    
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');
                    this.destroyElement();                     
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiWebApply({ code : this.code }).then(
                res => {
                    this.$toast('助力成功');
                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');
                    this.destroyElement();              
                },
                rej => {
                    this.destroyElement();

                    this.$store.commit("$_setShare", '');
                    localStorage.setItem('share', '');                    

                    this.$msg_modal({ type : 'share-error' , text : this.msg[rej.code] || rej.message});
                  
                },
            );
        },                
    },
}
</script>